import { render } from "./modal-event-detail.vue?vue&type=template&id=f2678624&scoped=true"
import script from "./modal-event-detail.vue?vue&type=script&lang=js"
export * from "./modal-event-detail.vue?vue&type=script&lang=js"

import "./modal-event-detail.vue?vue&type=style&index=0&id=f2678624&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2678624"],['__file',"src/components/calendar/modal-event-detail/modal-event-detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2678624"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2678624', __exports__)) {
    api.reload('f2678624', __exports__)
  }
  
  module.hot.accept("./modal-event-detail.vue?vue&type=template&id=f2678624&scoped=true", () => {
    api.rerender('f2678624', render)
  })

}


export default __exports__